"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { MAX_COPY_TEXT_LENGTH } from "@/data/constants";
import { usePreventCopy } from "@/hooks/usePreventCopy";

function buildPageUrl(origin: string, pathname: string): string {
  const cleanPath = pathname.replace(/^\/(te-IN|en-IN)(?=\/|$)/i, "") || "/";
  try {
    return decodeURI(`${origin}${cleanPath}`);
  } catch {
    return `${origin}${cleanPath}`;
  }
}

export const CopyPrevention = () => {
  const [currentUrl, setCurrentUrl] = useState("");
  const pathName = usePathname();

  usePreventCopy(MAX_COPY_TEXT_LENGTH, currentUrl ? `Read more at: ${currentUrl}` : "");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(buildPageUrl(window.location.origin, pathName));
    }
  }, [pathName]);

  return null;
};
